@import 'styles/mixins';
@import 'styles/variables';

.cursorContainer {
  position: relative;
}

.outOfViewContainer {
  position: absolute;
  left: 0;
  z-index: 3; // anything > than TOC which is a 2
}

.direction-top {
  top: calc(58px + var(--total-navbar-height) - $action-bar-height);
}

.direction-bottom {
  bottom: 20px;
}
